import { Flex, Typography, Button } from "antd";
import styled from "styled-components";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

const { Title } = Typography;

export default function Page({ title, content, extra }) {
  const navigate = useNavigate();
  const location = useLocation();

  const isBasePath = location.pathname === "/";

  return (
    <>
      <Flex justify="space-between" align="center">
        <Flex align="center">
          {!isBasePath && (
            <BackButton onClick={() => navigate(-1)}>
              <LeftOutlined />
            </BackButton>
          )}
          <Title
            level={3}
            style={{ margin: 0, marginLeft: isBasePath ? 0 : 8 }}
          >
            {title}
          </Title>
        </Flex>
        <div>{extra}</div>
      </Flex>

      <Content>{content}</Content>
    </>
  );
}

const BackButton = styled(Button)`
  border: none;
  background: transparent;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;
  height: auto;

  &:hover {
    color: #1890ff;
    background: none;
  }

  svg {
    font-size: 18px;
  }
`;

const Content = styled.div`
  margin-top: 8px;
`;
